import React from "react";
import { useWorkspaceDefaultImage } from "../../../utils/defaultImages";
import type { CustomWorkspacePreviewProps } from "./CustomWorkspacePreview";
import WorkspaceImagePreview from "./WorkspaceImagePreview";

type DefaultWorkspacePreviewProps = Omit<
  CustomWorkspacePreviewProps,
  "setIsVisible" | "token"
>;

const DefaultWorkspacePreview = ({
  canEditLabels,
  myWorkspaceMetadata,
  showEditLabelPrompt,
  showWorkspaceWeight,
}: DefaultWorkspacePreviewProps) => {
  const imgSrc = useWorkspaceDefaultImage(myWorkspaceMetadata.workspaceType);

  return (
    <WorkspaceImagePreview
      canEditLabels={canEditLabels}
      imgSrc={imgSrc}
      myWorkspaceMetadata={myWorkspaceMetadata}
      showEditLabelPrompt={showEditLabelPrompt}
      showWorkspaceWeight={showWorkspaceWeight}
    />
  );
};

export default DefaultWorkspacePreview;
